export enum ListingAfterHoursMessageType {
    None = 0,
    Towing = 1,
    Road = 2,
    Emergency = 3
}